import React from "react";
import { clearAddToBasketMessage, clearErrors, clearInfoMessage, clearSuccessMessage } from "../../app/store/alerts/alertsActions";
import { connect } from "react-redux";
import { State } from "../../app/store";
import ErrorAlerts from "./ErrorAlerts";
import SuccessAlerts from "./SuccessAlerts";
import InfoAlerts from "./InfoAlerts";

interface IProps {
  alerts: {
    errors: string[] | null;
    success: string | null;
    info: string[] | null;
    addToBasket: string | null;
  };
  clearErrors: Function;
  clearSuccessMessage: Function;
  clearInfoMessage: Function;
  clearAddToBasketMessage: Function;
}

export const AlertsHandler: React.FC<IProps> = ({
  alerts,
  clearErrors,
  clearSuccessMessage,
  clearInfoMessage,
}: IProps) => {
  return (
    <React.Fragment>
      <ErrorAlerts onHide={clearErrors} errors={alerts.errors} />
      {/* <AddToBasket AddToBasket={"ss"} onHide={clearSuccessMessage} /> */}

      <SuccessAlerts onHide={clearSuccessMessage} successText={alerts.success} />
      <InfoAlerts info={alerts.info} onHide={clearInfoMessage} />
      {/* {alerts.addToBasket && <AddToBasketAlerts info={alerts.addToBasket} onHide={clearAddToBasketMessage} />}
       */}
      {/* <AddToBasketAlerts info={alerts.addToBasket} onHide={clearAddToBasketMessage} /> */}
    </React.Fragment>
  );
};

const mapStateToProps = (state: State) => ({
  alerts: state.alerts,
});

export default connect(mapStateToProps, {
  clearErrors,
  clearSuccessMessage,
  clearInfoMessage,
  clearAddToBasketMessage,
})(AlertsHandler);
